import { render, staticRenderFns } from "./whiteTitleColorImgWidge.vue?vue&type=template&id=e8461e1a&scoped=true"
import script from "./whiteTitleColorImgWidge.vue?vue&type=script&lang=js"
export * from "./whiteTitleColorImgWidge.vue?vue&type=script&lang=js"
import style0 from "./whiteTitleColorImgWidge.vue?vue&type=style&index=0&id=e8461e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8461e1a",
  null
  
)

export default component.exports